/* eslint-disable object-curly-newline */
import { Grid, makeStyles } from '@material-ui/core';
import { mergeClasses } from '@material-ui/styles';
import clsx from 'clsx';
import React, { Suspense, useState } from 'react';
import Sidebar, { SidebarSkeleton, } from '@dev-togetherprice/components.sidebar';
import FullTopAppBar from '@dev-togetherprice/components.full-top-app-bar';
import Page from '@dev-togetherprice/components.page';
import PageHeader from '@dev-togetherprice/components.page-header';
import NavBar from '@dev-togetherprice/components.navbar';
import CannotCreateError from './components/CannotCreateError';
const useStyles = makeStyles((theme) => ({
    page: {},
    header: {
        [theme.breakpoints.up('md')]: {
            backgroundColor: theme.palette.common.white,
            paddingBottom: 0,
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            zIndex: 999,
        },
    },
    wrapper: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        flex: '1 1 auto',
        [theme.breakpoints.up('md')]: {
            marginTop: '90px',
        },
    },
    mobileWrapper: {
        borderTopLeftRadius: theme.spacing(10),
        width: '100%',
        display: 'flex',
        flex: '1 1 auto',
        justifyContent: 'flex-end',
    },
    mobileInner: {
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.down('sm')]: {
            flex: '1 1 auto',
            paddingBottom: ({ hasNavBar }) => (hasNavBar ? 80 : 'unset'),
            width: '100%',
        },
        [theme.breakpoints.up('md')]: {
            transition: '.4s',
            width: 'calc(100% - 325px)',
            flex: '0 1 auto',
            position: 'relative',
            overflow: 'hidden',
        },
    },
    mobileInnerOpened: {
        [theme.breakpoints.up('md')]: {
            width: 'calc(100% - 80px) !important',
        },
    },
    rounded: {
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
        width: '100px',
        height: '100px',
        position: 'fixed',
        top: '60px',
        left: '295px',
        transition: '.4s',
        borderTop: '30px solid white',
        borderLeft: '30px solid white',
        borderTopLeftRadius: '100%',
        zIndex: 50,
    },
    roundedClosed: {
        borderTop: '20px solid white',
        borderLeft: '20px solid white',
        top: '70px !important',
        left: '60px !important',
        width: '50px !important',
        height: '50px !important',
    },
}));
const PageWrapper = ({ children, isPublic = false, headerChildren, activeTab, externalChildren, hasNavBar, navigateToUrl, classes: newClasses = {}, SidebarProps, FullTopAppBarProps, onCannotCreatePost: newOnCannotCreatePost, }) => {
    const baseClasses = useStyles({ hasNavBar });
    const [openError, setOpenError] = useState(false);
    const navbarStatus = window.localStorage.getItem('navbar.status');
    const [showSidebar, setShowSidebar] = useState(navbarStatus === null || navbarStatus === 'true');
    const onCannotCreatePost = () => setOpenError(true);
    const classes = mergeClasses({
        baseClasses,
        newClasses,
        Component: PageWrapper,
    });
    const toggleSidebar = () => {
        localStorage.setItem('navbar.status', (!showSidebar).toString());
        setShowSidebar((prev) => !prev);
    };
    return (React.createElement(Page, { className: classes.page, disableGutters: true },
        React.createElement(PageHeader, { className: classes.header },
            React.createElement(FullTopAppBar, Object.assign({ isPublic: isPublic, navigateToUrl: navigateToUrl, desktopProps: {
                    toggleSidebar,
                    showSidebar,
                    onCannotCreatePost: newOnCannotCreatePost || onCannotCreatePost,
                } }, FullTopAppBarProps, { mobileProps: Object.assign({}, FullTopAppBarProps === null || FullTopAppBarProps === void 0 ? void 0 : FullTopAppBarProps.mobileProps) })),
            headerChildren),
        React.createElement(Grid, { className: classes.wrapper },
            React.createElement(Suspense, { fallback: React.createElement(SidebarSkeleton, { showSidebar: showSidebar }) },
                React.createElement(Sidebar, Object.assign({ showSidebar: showSidebar, activeTab: activeTab, navigateToUrl: navigateToUrl, isPublic: isPublic }, SidebarProps))),
            React.createElement(Grid, { className: classes.mobileWrapper },
                React.createElement(Grid, { className: clsx(classes.mobileInner, {
                        [classes.mobileInnerOpened]: !showSidebar,
                    }) },
                    React.createElement("div", { className: clsx(classes.rounded, {
                            [classes.roundedClosed]: !showSidebar,
                        }) }),
                    children))),
        externalChildren,
        hasNavBar && (React.createElement(Suspense, { fallback: React.createElement("div", null) },
            React.createElement(NavBar, { onCannotCreatePost: newOnCannotCreatePost || onCannotCreatePost, navigateToUrl: navigateToUrl }))),
        React.createElement(CannotCreateError, { open: openError, setOpen: setOpenError })));
};
export default PageWrapper;
